// Utilities for aggregating scanner history into daily stats
function formatDateKey(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function aggregateHistoryByDay(history = [], days = 30) {
  // normalize to array
  const now = new Date();
  // Create full map for last `days` days
  const statsMap = {};
  for (let i = 0; i < days; i++) {
    const d = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - (days - 1 - i)
    );
    const key = formatDateKey(d);
    statsMap[key] = { date: key, tokens: 0, docs: 0 };
  }

  for (const entry of history || []) {
    const created = entry.createdAt ? new Date(entry.createdAt) : null;
    if (!created) continue;
    const key = formatDateKey(created);
    // tokens used heuristics: tokensUsed, tokensRequired, pages, or 0
    const tokensUsed =
      Number(entry.tokensUsed ?? entry.tokensRequired ?? entry.pages ?? 0) || 0;
    const done = (entry.status || "").toLowerCase() === "done";
    if (!statsMap[key]) statsMap[key] = { date: key, tokens: 0, docs: 0 };
    statsMap[key].tokens += tokensUsed;
    if (done) statsMap[key].docs += 1;
  }

  return Object.values(statsMap).sort((a, b) => (a.date > b.date ? 1 : -1));
}

export function getTodayTotals(aggregated = []) {
  const todayKey = formatDateKey(new Date());
  const today = aggregated.find((a) => a.date === todayKey) || {
    tokens: 0,
    docs: 0,
  };
  return { tokens: today.tokens || 0, docs: today.docs || 0 };
}

const usageUtils = {
  aggregateHistoryByDay,
  getTodayTotals,
};

export default usageUtils;
